import { Component, OnInit } from "@angular/core";
import { LanguageService } from "src/app/services/language-service/language.service";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { distinctUntilChanged } from "rxjs/operators";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-language-switcher",
  templateUrl: "./language-switcher.component.html",
  styleUrls: ["./language-switcher.component.scss"],
  imports: [IonicModule, TranslateModule, ReactiveFormsModule, CommonModule],
})
export class LanguageSwitcherComponent implements OnInit {
  public lang = new FormControl('');
  public languages = [];
  public selected;

  constructor(private languageService: LanguageService) {}

  ngOnInit() {
    this.languages = this.languageService.getLanguage();
    this.languageService.selected.subscribe((res) => {
      if (res) {
        this.lang.setValue(res); 
      }
    });
    this.onChanges();
  }

  onChanges() {
    this.lang.valueChanges.pipe(distinctUntilChanged()).subscribe((val: string) => {
      if (typeof val === 'string') {
        this.languageService.setLanguage(val); 
      }
    });
  }
}
